export default __webpack_public_path__ + "static/media/Facebook.c23a4e61.png";